<script setup lang="ts">
/**
 * A filter's pill: outlined while unset, iris (selected) once it narrows the list. Removable
 * (default) adds its own × button once active; `removable: false` makes it a plain toggle.
 */
withDefaults(
  defineProps<{
    active: boolean
    removable?: boolean
    // eslint-disable-next-line vue/require-default-prop -- must stay absent; no remove button without it
    removeLabel?: string | undefined
  }>(),
  { removable: true },
)

const emit = defineEmits<{ remove: [] }>()
</script>

<template>
  <span
    class="relative inline-flex h-[var(--density-control)] max-w-full items-stretch rounded-[var(--radius-control)] border whitespace-nowrap"
    :class="
      active
        ? 'border-[color:color-mix(in_srgb,var(--color-accent)_40%,transparent)] bg-[color:color-mix(in_srgb,var(--color-accent)_10%,transparent)] font-semibold text-[color:var(--color-accent)]'
        : 'border-[color:var(--color-border-control)] bg-[color:var(--color-surface)] text-[color:var(--color-text)] hover:bg-[color:var(--color-surface-raised)]'
    "
  >
    <slot />
    <button
      v-if="active && removable && removeLabel !== undefined"
      type="button"
      :aria-label="removeLabel"
      class="flex w-[var(--density-target-min)] shrink-0 items-center justify-center rounded-[var(--radius-control)] mr-[var(--space-tight)]"
      @click="emit('remove')"
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 16 16"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        stroke-width="1.7"
      >
        <path d="M4 4l8 8M12 4l-8 8" />
      </svg>
    </button>
  </span>
</template>
